import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter, FlexCenter, HideScrollbar } from '../../../global/commonStyle';

interface Props {
  isLoading?: boolean;
}

const Group = styled.div<Props>`
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: var(--background-secondary);
  margin: auto;
  height: 100vh;
  ${HideScrollbar}
  ${(props: Props) =>
    props.isLoading &&
    css`
      cursor: wait;
    `}
`;

const Content = styled.div`
  width: 100%;
  max-width: 754px;
  margin: var(--space-80) auto;
  display: flex;
  background-color: var(--background-secondary);
  flex-direction: column;
  gap: var(--space-32);
  .button {
    padding-bottom: var(--space-24);
    margin-inline: auto;
  }
  ${mobile_xl(css`
    max-width: 100%;
    padding: var(--space-48) var(--space-20) var(--space-0);
    margin: var(--space-0);
  `)}
`;

const Header = styled.div`
  ${AlignCenter}
  flex-direction: column;
  gap: var(--space-14);
  ${mobile_xl(css`
    gap: var(--space-32);
  `)}
`;

const Icon = styled.div`
  ${FlexCenter}
  ${mobile_xl(css`
    .svg-icon {
      width: 40px;
      height: 40px;
    }
  `)}
`;

const Title = styled.h1`
  ${Typography.heading_lg}
  color: var(--text-primary);
  margin: var(--space-0);
`;

const Organization = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-20);
  justify-content: center;
  margin-top: var(--space-18);
  color: var(--text-primary);
  ${mobile_xl(css`
    margin-top: var(--space-0);
    gap: var(--space-12);
  `)}
`;

const BoxContent = styled.button`
  ${AlignCenter}
  gap: var(--space-12);
  width: 100%;
  max-width: 238px;
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: var(--border-radius-12);
  padding: var(--space-12);
  cursor: pointer;
  .name-text {
    ${Typography.body_lg_medium}
    color: var(--text-primary)
  }
  ${mobile_xl(css`
    border-radius: var(--border-radius-12);
    max-width: -webkit-fill-available;
    border: 0.5px solid var(--border-primary);
  `)}
`;

const IconDiv = styled.div`
  ${FlexCenter}
  padding: var(--space-8);
  background-color: var(--background-tertiary);
  border-radius: var(--border-radius-6);
  border: 0.5px solid var(--border-primary);
  svg {
    fill: var(--text-secondary);
  }
`;

export { Group, Content, Header, Icon, Title, Organization, BoxContent, IconDiv };
